import { Switch, Tooltip } from 'antd';

interface UnitSwitchProps {
	useInches: boolean;
	onChange: (useInches: boolean) => void;
	disabled?: boolean;
	disabledReason?: string;
}

const UnitSwitch = ({
	useInches,
	onChange,
	disabled,
	disabledReason,
}: UnitSwitchProps) => (
	<Tooltip title={disabled ? disabledReason : 'Programs are stored in metric'}>
		<Switch
			checked={useInches}
			onChange={onChange}
			disabled={disabled}
			checkedChildren="in"
			unCheckedChildren="mm"
		/>
	</Tooltip>
);

export default UnitSwitch;
